import { Link } from "react-router-dom";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
  SidebarMenuSub,
  SidebarMenuSubItem,
  SidebarSeparator,
} from "@/components/ui/sidebar";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { menuItems } from "@/constants/menu";
import { Sun, ChevronRight } from "lucide-react";

export function AppSidebar() {
  return (
    <Sidebar>
      <SidebarContent className="bg-green-950">
        <SidebarGroup>
          <div className="flex items-center gap-2 px-2 pb-3">
            <Sun className="w-5 h-5 text-lime-500" />
            <span className="text-2xl text-white">Shirohana</span>
          </div>
          <SidebarGroupLabel className="text-gray-400">
            Plantation
          </SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {menuItems.map((item) => (
                <SidebarMenuItem key={item.title}>
                  {item.children ? (
                    <Collapsible
                      defaultOpen={false}
                      className="group/collapsible w-full"
                    >
                      <CollapsibleTrigger asChild>
                        <SidebarMenuButton className="w-full justify-between hover:bg-green-900 active:bg-green-900 focus:bg-green-900">
                          <div className="flex items-center gap-2">
                            <item.icon className="w-4 h-4 text-gray-400" />
                            <span className="text-gray-400">{item.title}</span>
                          </div>
                          <ChevronRight className="h-4 w-4 transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90 text-gray-400" />
                        </SidebarMenuButton>
                      </CollapsibleTrigger>
                      <CollapsibleContent>
                        <SidebarMenuSub>
                          {item.children.map((child) => (
                            <SidebarMenuSubItem key={child.title}>
                              <SidebarMenuButton
                                asChild
                                className="hover:bg-green-900 active:bg-green-900 focus:bg-green-900"
                              >
                                <Link to={child.url.replace("#", "")}>
                                  <child.icon className="w-4 h-4 text-gray-400" />
                                  <span className="text-gray-400">
                                    {child.title}
                                  </span>
                                </Link>
                              </SidebarMenuButton>
                            </SidebarMenuSubItem>
                          ))}
                        </SidebarMenuSub>
                      </CollapsibleContent>
                    </Collapsible>
                  ) : (
                    <SidebarMenuButton
                      asChild
                      className="hover:bg-green-900 active:bg-green-900 focus:bg-green-900"
                    >
                      <Link to={item.url}>
                        <item.icon className="w-4 h-4 text-gray-400" />
                        <span className="text-gray-400">{item.title}</span>
                      </Link>
                    </SidebarMenuButton>
                  )}
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}
